import { useSelector } from 'react-redux';
import { selectInceptionDates } from '../state/selectors';

export const useInceptionDates = (): Record<string, string | null> => {
  return useSelector(selectInceptionDates);
};
